import { connect } from 'react-redux';
import { transformObjKeysToLowerCase } from '../../modules/string';
import FontAwesome from 'react-fontawesome';
import React, { Component } from 'react';
import Skeleton from '../../components/Skeleton/Skeleton';
import Timeline from '../../components/Timeline/Timeline';

import './YourInformation.scss';

export class YourInformation extends Component {
    formatZipCode(zipcode) {
        let formattedZip = '';
        if (zipcode) formattedZip = zipcode.slice(0, 5);
        return formattedZip;
    }

    renderAgentInfo(agentInfo) {
        if (!agentInfo) return null;

        const {
            Name = '',
            AgencyAddress1 = '',
            AgencyAddress2 = '',
            AgencyCity = '',
            AgencyState = '',
            AgencyZip = '',
            AgencyPhoneNumber = ''
        } = agentInfo;

        return (
            <div>
                {`${Name ? Name + '\n' : ''}`}
                {`${AgencyAddress1 ? AgencyAddress1 + '\n' : ''}`}
                {`${AgencyAddress2 ? AgencyAddress2 + '\n' : ''}`}
                {`${
                    AgencyCity
                        ? AgencyCity +
                          ', ' +
                          AgencyState +
                          ' ' +
                          this.formatZipCode(AgencyZip) +
                          '\n'
                        : ''
                }`}
                {`${AgencyPhoneNumber}`}
            </div>
        );
    }

    renderCustomerInfo(customerInfo) {
        if (!customerInfo) return null;

        const { firstName = '', lastName = '', policyAddress } = customerInfo;

        let addressLineOne = '';
        let addressLineTwo = '';
        let city = '';
        let state = '';
        let zipcode = '';
        let lastLineOfAddress = '';

        if (policyAddress) {
            addressLineOne = policyAddress.addressLineOne;
            addressLineTwo = policyAddress.addressLineTwo;
            city = policyAddress.city;
            state = policyAddress.state;
            zipcode = policyAddress.zipcode;
            lastLineOfAddress = `${city}, ${state} ${this.formatZipCode(zipcode)}`;
        }

        return (
            <div>
                {`${firstName} ${lastName} \n`}
                {`${addressLineOne ? addressLineOne + '\n' : ''}`}
                {`${addressLineTwo ? addressLineTwo + '\n' : ''}`}
                {lastLineOfAddress}
            </div>
        );
    }

    render() {
        if (!this.props.customer.isAuthenticated) return null;
        const hasError = this.props.details.hasError;
        const isLoading = this.props.details.isLoading;
        let customerInfo;
        let agentInfo;

        if (!isLoading) {
            customerInfo = transformObjKeysToLowerCase(this.props.details.customerData);
            agentInfo = transformObjKeysToLowerCase(this.props.details.agencyData);
        }

        return (
            <Timeline
                seperator="CUSTOMER DETAILS"
                heading="your information"
                icon={
                    <FontAwesome
                        className="primary-yellow con md image_center icon15"
                        name="id-card"
                        datacy="id-card"
                        size="2x"
                    />
                }>
                We’ve been working with your agent on your policy. Here is the information they’ve
                shared with us.
                <p>
                    <strong>If something doesn’t look right, contact your agent to update.</strong>
                </p>
                <div className="your-information title-case">
                    <div className="data-container left" datacy="your-information">
                        <p className="data-header">Your Information</p>
                        {this.renderCustomerInfo(customerInfo) || (
                            <Skeleton count={3} hasError={hasError} />
                        )}
                    </div>
                    <div className="data-container" datacy="agent-information">
                        <p className="data-header">Your Agent Information</p>
                        {this.renderAgentInfo(agentInfo) || (
                            <Skeleton count={4} hasError={hasError} />
                        )}
                    </div>
                </div>
            </Timeline>
        );
    }
}

export function mapStoreToProps(store) {
    return {
        customer: store.customer,
        details: store.details,
        app: store.app
    };
}

export default connect(mapStoreToProps)(YourInformation);



// WEBPACK FOOTER //
// ./src/containers/YourInformation/YourInformation.jsx